import React from "react";
import { Stack, Typography, Box, Chip, Skeleton, Button } from "@mui/material";

/**
 * Tab 3 de Panel Insights: No Visit
 * Muestra distribución por timeframe, stat grande de 12+ meses, contactability.
 */
export default function TabNoVisit({ data, loading, onCreateTask }) {
  if (loading) {
    return (
      <Stack spacing={1.5}>
        <Skeleton variant="rounded" height={50} />
        <Skeleton variant="rounded" height={40} />
        <Skeleton variant="rounded" height={30} />
      </Stack>
    );
  }

  if (!data) return null;

  const { distribution, contactability, totalRecallEligible } = data;

  const total = distribution?.total || 0;
  const months12 = distribution?.months12plus || 0;
  const pct12 = total > 0 ? Math.round((months12 / total) * 100) : 0;

  return (
    <Stack spacing={2}>
      {/* Distribution mini-cards */}
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
        <DistCard label="12+ Mo" value={months12} color="#DC2626" bgColor="#FEE2E2" />
        <DistCard label="9 Mo" value={distribution?.months9 || 0} color="#9A3412" bgColor="#FFEDD5" />
        <DistCard label="6 Mo" value={distribution?.months6 || 0} color="#92400E" bgColor="#FEF3C7" />
      </Stack>

      {/* Big stat */}
      <Box
        sx={{
          p: 1.5,
          borderRadius: 2,
          bgcolor: "#FEF2F2",
          border: "1px solid #FECACA",
        }}
      >
        <Typography variant="h5" fontWeight={800} sx={{ color: "#DC2626" }}>
          {pct12}%
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
          without a visit in 12+ months
        </Typography>
      </Box>

      {/* Contactability */}
      <Stack spacing={0.5}>
        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: "uppercase", fontSize: "0.65rem", letterSpacing: 0.5 }}>
          Contactability
        </Typography>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
          {contactability?.withPhone != null && (
            <Chip
              label={`Phone: ${contactability.withPhone.toLocaleString()}`}
              size="small"
              sx={{ height: 22, fontSize: "0.66rem", fontWeight: 600, bgcolor: "#F0FDF4", color: "#166534" }}
            />
          )}
          {contactability?.withEmail != null && (
            <Chip
              label={`Email: ${contactability.withEmail.toLocaleString()}`}
              size="small"
              sx={{ height: 22, fontSize: "0.66rem", fontWeight: 600, bgcolor: "#EFF6FF", color: "#1E40AF" }}
            />
          )}
        </Stack>
      </Stack>

      {/* Recall eligible + CTA */}
      {totalRecallEligible != null && (
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.68rem" }}>
          {totalRecallEligible.toLocaleString()} recall eligible patients
        </Typography>
      )}

      {onCreateTask && (
        <Button
          variant="outlined"
          size="small"
          onClick={() =>
            onCreateTask({
              title: `Recall Campaign: ${months12} patients (12+ mo)`,
              category: "outreach_call",
              priority: "medium",
            })
          }
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
            borderRadius: 2,
            alignSelf: "flex-start",
            borderColor: "#DC2626",
            color: "#DC2626",
            "&:hover": { borderColor: "#991B1B", bgcolor: "#FEF2F2" },
          }}
        >
          Start Recall Campaign
        </Button>
      )}
    </Stack>
  );
}

function DistCard({ label, value, color, bgColor }) {
  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 1.5,
        bgcolor: bgColor,
        minWidth: 70,
        textAlign: "center",
      }}
    >
      <Typography variant="subtitle2" fontWeight={800} sx={{ color, lineHeight: 1.1 }}>
        {value.toLocaleString()}
      </Typography>
      <Typography variant="caption" sx={{ fontSize: "0.62rem", color }}>
        {label}
      </Typography>
    </Box>
  );
}
